// SPDX-License-Identifier: AGPL-3.0-or-later
import arbor from '@app/media/voice-previews/codex/arbor.mp3';
import breeze from '@app/media/voice-previews/codex/breeze.mp3';
import cove from '@app/media/voice-previews/codex/cove.mp3';
import ember from '@app/media/voice-previews/codex/ember.mp3';
import juniper from '@app/media/voice-previews/codex/juniper.mp3';
import maple from '@app/media/voice-previews/codex/maple.mp3';
import sol from '@app/media/voice-previews/codex/sol.mp3';
import spruce from '@app/media/voice-previews/codex/spruce.mp3';
import vale from '@app/media/voice-previews/codex/vale.mp3';

/** Actual Codex V3 recordings; previews never open a conversation or use workplace tools. */
export const CODEX_VOICE_PREVIEWS: Readonly<Record<string, string>> = {
	arbor,
	breeze,
	cove,
	ember,
	juniper,
	maple,
	sol,
	spruce,
	vale,
};
